import React from 'react'
import { AiFillCloseCircle, AiOutlineClose } from 'react-icons/ai';
import { Box, Modal } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function ModalComponent({ open, onClose, closeIcon=false, children, mxclass, style={} }) {
    const theme = useTheme()
    return (
        <Modal open={open} onClose={onClose} className={mxclass}>
            <Box className='cs-modal' sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '900px', ...style }}>
                {closeIcon && <Box sx={{ position: 'absolute', top: '0px', right: '0px', padding: '15px', cursor: 'pointer',zIndex: 1, }} onClick={onClose} className=''>
                    <Box
                sx={{
                    backgroundColor: '#E8E9EA',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
                onClick={onClose}
                >
                <AiOutlineClose size={24} color="black" />
                </Box>
                </Box>}
               {children}
            </Box>
        </Modal>
    )
}

export default ModalComponent